module.exports = __webpack_public_path__ + "static/media/finger.b07fe4a5.png";